<template>
  <div id="awardWorks" @click="clickAreaFn($event)">
    <div id="occupied"></div>
    <div class="top-wrap">
      <div class="form_item" @click="showPopup('group')">
        <div class="input">
          <template>
            <p class="placeholder" v-if="!group">
              请选择组别
            </p>
            <p class="select-div" v-else>
              {{ groupTxt }}
            </p>
            <!-- <img class="icon-close" src="../assets/images/icon_close.png" /> -->
          </template>

          <van-popup
            v-model="showGroupPop"
            position="bottom"
            :style="{ height: '45%' }"
          >
            <van-picker
              show-toolbar
              value-key="name"
              :columns="groupArr"
              @confirm="confirmGroupPop"
            />
          </van-popup>
        </div>
        <div class="icon-close">
          <img src="../assets/images/btn_arrows.png" />
        </div>
      </div>

      <div class="special award-box" v-if="specialArr.length">
        <div class="title">
          <div class="label">
            <div class="txt">大赛特别奖</div>
            <div class="orange-line"></div>
          </div>
          <div class="cut-line"></div>
        </div>
        <WorkBox :workArr="specialArr" :group="group"></WorkBox>
      </div>
      <!-- 隐藏123等奖 -->
      <!-- <div class="first award-box">
        <div class="title">
          <div class="label">
            <div class="txt">一等奖</div>
            <div class="orange-line"></div>
          </div>
          <div class="cut-line"></div>
        </div>
        <WorkBox :workArr="firstArr" :group="group"></WorkBox>
      </div>
      <div class="second award-box">
        <div class="title">
          <div class="label">
            <div class="txt">二等奖</div>
            <div class="orange-line"></div>
          </div>
          <div class="cut-line"></div>
        </div>
        <WorkBox :workArr="secondArr" :group="group"></WorkBox>
      </div>
      <div class="third award-box">
        <div class="title">
          <div class="label">
            <div class="txt">三等奖</div>
            <div class="orange-line"></div>
          </div>
          <div class="cut-line"></div>
        </div>
        <WorkBox :workArr="thirdArr" :group="group"></WorkBox>
      </div> -->
    </div>
    <div id="poOtherBox"></div>
    <div class="bottom-wrap">
      <div class="label-choose">
        <ul class="box">
          <li
            v-for="(other, index) in otherArr"
            :key="index"
            :class="{ checked: index == choose }"
            @click="changeTab(index)"
          >
            {{ other.name }}
            <i :class="{ checked: index == choose }"></i>
          </li>
        </ul>
      </div>
      <div class="form">
        <div class="form_item">
          <div class="input" @click="showPopup('province')">
            <template>
              <p class="placeholder" v-if="!form.province">
                请选择省份
              </p>
              <p class="select-div" v-else>
                {{ provinceValue.name }}
              </p>
            </template>

            <van-popup
              v-model="showProvincePop"
              position="bottom"
              :style="{ height: '45%' }"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="provinceArr"
                @confirm="confirmProvincePop"
              />
            </van-popup>
          </div>
          <div class="icon-close" @click="clearData('province')">
            <img src="../assets/images/btn_close.png" />
          </div>
        </div>

        <div class="form_item">
          <div class="input" @click="showPopup('city')">
            <template>
              <p class="placeholder" v-if="!form.city">
                请选择城市
              </p>
              <p class="select-div" v-else>
                {{ cityValue.name }}
              </p>
            </template>

            <van-popup
              v-model="showCityPop"
              position="bottom"
              :style="{ height: '45%' }"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="cityArr"
                @confirm="confirmCityPop"
              />
            </van-popup>
          </div>
          <div class="icon-close" @click="clearData('city')">
            <img src="../assets/images/btn_close.png" />
          </div>
        </div>

        <div class="form_item">
          <div class="input" @click="showPopup('school')">
            <template>
              <p class="placeholder" v-if="!form.school">
                请选择学校
              </p>
              <p class="select-div" v-else>
                {{ schoolValue.name }}
              </p>
            </template>

            <van-popup
              v-model="showSchoolPop"
              position="top"
              :style="{ height: '45%' }"
            >
              <div class="search-bar">
                <input
                  class="search-input"
                  id="school"
                  type="text"
                  name="school"
                  v-model="schoolKeyWord"
                  @input="searchSchool"
                  placeholder="请输入搜索关键词"
                />
              </div>
              <van-picker
                show-toolbar
                value-key="name"
                :columns="schoolArr"
                @confirm="confirmSchoolPop"
              />
            </van-popup>
          </div>
          <div class="icon-close" @click="clearData('school')">
            <img src="../assets/images/btn_close.png" />
          </div>
        </div>
        <div class="form_item uin-bar">
          <input
            class="input"
            id="uin"
            type="number"
            name="uin"
            v-model="form.uin"
            placeholder="请输入迷你号"
          />
          <div class="icon-search" @click="searchUid">
            <img src="../assets/images/icon_search.png" />
          </div>
        </div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="无更多数据"
        @load="onLoad"
      >
        <WorkBox :workArr="otherListArr" :group="group"></WorkBox>
      </van-list>
    </div>
    <div class="btn-location">
      <!-- <img
        class="img-to-other"
        src="../assets/images/btn_toOther_award.png"
        @click="toOtherBox"
      /> -->
      <img
        class="img-to-top"
        src="../assets/images/btn_toTop.png"
        @click="toTop"
      />
    </div>
  </div>
</template>

<script>
import { seasonId, divisionIdM, divisionIdG } from '../common/argumentId';
import WorkBox from '../components/workBox';
export default {
  name: 'awardWorks',
  components: {
    WorkBox
  },
  data() {
    return {
      group: '50',
      isChangeGroup: false,
      showGroupPop: false,
      showProvincePop: false,
      showCityPop: false,
      showSchoolPop: false,
      provinceValue: {},
      cityValue: {},
      schoolValue: {},
      provinceArr: [],
      cityArr: [],
      schoolArr: [],
      schoolKeyWord: '',
      uid: '',
      queryUid: '',
      groupTxt: '游戏制作组',
      groupArr: [
        { id: divisionIdM, name: '游戏制作组' },
        { id: divisionIdG, name: '模型制作组' }
      ],
      firstArr: [],
      secondArr: [],
      thirdArr: [],
      specialArr: [],
      otherArr: [], // 其他奖项数组
      worksVoList: [], // 模拟用
      choose: 0,
      form: {
        province: '',
        city: '',
        school: '',
        uin: '',
        aid: ''
      },
      finished: false,
      otherPage: 1,
      otherPageSize: 6,
      otherTimer: '',
      otherListArr: [], // 分页显示数组
      otherAllArr: [], // 未分页后端一次性返回的
      loading: false
    };
  },
  watch: {
    group: function() {
      this.isChangeGroup = true;
      this.queryTopThree();
      this.queryOtherAward();
    },
    'form.school': function(val) {
      if (val) {
        this.finished = false;
        this.otherPage = 1;
        this.otherPageSize = 6;
        this.otherTimer = '';
        this.otherListArr = [];
        this.otherAllArr = [];
        this.loading = false;
        this.queryAwardOfID(this.form.aid);
      }
    },
    'form.aid': function(val, oldValue) {
      if (oldValue != '' && !this.isChangeGroup) {
        this.form.aid = val;

        this.queryAwardOfID(this.form.aid);
      }
    },
    'form.uin': function(val) {
      if (!val) {
        this.queryAwardOfID(this.form.aid);
      }
    }
  },
  mounted() {
    this.$scroll('occupied');
    window.sessionStorage.setItem(
      'pathName',
      window.location.hash.split('#')[1]
    );
    this.queryTopThree();
    this.queryOtherAward();
    this.queryProvince();
    window.addEventListener('scroll', this.scrollEvent, false);
  },
  methods: {
    toOtherBox() {
      this.$scroll('poOtherBox');
    },
    toTop() {
      this.$scroll('occupied');
    },
    changeTab(val) {
      this.choose = val;
      this.form.aid = this.otherArr[val].id;
    },
    // 查前三
    async queryTopThree() {
      let divisionId = this.group == 60 ? divisionIdG : divisionIdM;
      let body = {
        seasonId,
        divisionId
      };
      try {
        const res = await this.$http.apiTopThree(body);
        const { data } = res.data;
        this.firstArr = data.champion;
        this.secondArr = data.second;
        this.thirdArr = data.third;
      } catch (error) {
        console.log(error);
      }
    },
    // 查其他
    async queryOtherAward() {
      let divisionId = this.group == 60 ? divisionIdG : divisionIdM;
      let body = {
        seasonId,
        divisionId
      };
      try {
        this.otherArr = [];
        const res = await this.$http.apiOtherAward(body);
        const { data } = res.data;
        data.forEach(item => {
          if (item.name.includes('特')) {
            this.specialArr = item.worksVoList;
          } else {
            this.otherArr.push(item);
          }
        });
        this.form.aid = this.otherArr[0].id;
        this.choose = 0;
        this.queryAwardOfID(this.form.aid);
      } catch (error) {
        console.log(error);
      }
    },
    // 根据奖项id查
    async queryAwardOfID(aid) {
      this.finished = false;
      this.otherPage = 1;
      this.otherPageSize = 6;
      this.otherTimer = '';
      this.otherListArr = [];
      this.loading = false;
      let divisionId = this.group == 60 ? divisionIdG : divisionIdM;

      let body = {
        seasonId,
        divisionId,
        aid
      };
      if (this.form.school) {
        Object.assign(body, { sid: this.form.school });
      }
      if (this.form.uin) {
        Object.assign(body, { uin: this.form.uin });
      }

      try {
        const res = await this.$http.apiAwardOfID(body);
        const { data } = res.data;
        this.otherAllArr = data.worksVoList;
        this.setList();
      } catch (error) {
        console.log(error);
      }
    },
    // 下拉加载更多
    onLoad() {
      clearTimeout(this.timer);
      this.finished = false;
      if (this.otherListArr.length === this.otherAllArr.length) {
        this.finished = true;
        return false;
      }
      this.timer = setTimeout(() => {
        this.loading = true;
        this.otherPage++;
        this.setList();
        this.loading = false;
      }, 1000);
    },
    setList() {
      let begin = (this.otherPage - 1) * this.otherPageSize;
      let end = this.otherPage * this.otherPageSize;
      let data = [];
      data = [...this.otherListArr, ...this.otherAllArr.slice(begin, end)];
      this.otherListArr = data;
    },
    // 查询省
    async queryProvince() {
      try {
        const res = await this.$http.apiProvince();
        if (res.data.data && res.data.data.length) {
          res.data.data.forEach(item => {
            this.provinceArr.push({
              name: item.name,
              provinceId: item.provinceId
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查询市
    async queryCity(pid) {
      this.cityArr = [];
      try {
        const res = await this.$http.apiCity({ pid });
        if (res.data.data && res.data.data.length) {
          res.data.data.forEach(item => {
            this.cityArr.push({
              name: item.name,
              cityId: item.cityId
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    //  查学校
    async querySchool(val) {
      if (val) {
        try {
          const res = await this.$http.apiSchool({
            provinceId: this.form.province,
            cityId: this.form.city,
            type: 3,
            name: val
          });
          const { data } = res.data;
          this.schoolArr = res.data.data;
          if (data.length) {
            this.schoolArr = res.data.data;
          } else {
            this.schoolArr = [
              {
                id: 'no',
                name: '暂无数据',
                disabled: true
              }
            ];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 确认省选择
    confirmProvincePop(val) {
      this.form.province = val.provinceId;
      this.provinceValue = {
        name: val.name,
        provinceId: val.provinceId
      };
      // 查询对应的市 清空城市学校
      this.form.city = '';
      this.queryCity(this.form.province);
      this.form.school = '';
      this.schoolKeyWord = '';
      this.schoolArr = [];
      this.schoolValue = {
        name: '',
        schoolId: ''
      };
    },
    // 确认市选择
    confirmCityPop(val) {
      this.form.city = val.cityId;
      this.cityValue = {
        name: val.name,
        cityId: val.cityId
      };
      this.form.school = '';
      this.schoolKeyWord = '';
      this.schoolArr = [];
      this.schoolValue = {
        name: '',
        schoolId: ''
      };
    },
    // 搜索学校
    searchSchool() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.querySchool(this.schoolKeyWord);
      }, 300);
    },
    // 确认学校选择
    confirmSchoolPop(val) {
      if (val && val.id !== 'no') {
        this.form.school = val.id;
        this.schoolKeyWord = val.name;
        this.schoolValue = {
          name: val.name,
          schoolId: val.id
        };
      }
    },
    searchUid() {
      this.finished = false;
      this.otherPage = 1;
      this.otherPageSize = 6;
      this.otherTimer = '';
      this.otherListArr = [];
      this.otherAllArr = [];
      this.loading = false;
      this.queryUid = this.uid;
      this.queryAwardOfID(this.form.aid);
    },
    clearData(val) {
      if (val == 'province') {
        this.form.province = '';
        this.form.city = '';
        this.form.school = '';
        this.provinceValue = {};
        this.cityValue = {};
        this.schoolValue = {};
        this.cityArr = [];
        this.schoolArr = [];
        this.schoolKeyWord = '';
      }
      if (val == 'city') {
        this.form.city = '';
        this.form.school = '';
        this.cityValue = {};
        this.schoolValue = {};
        this.schoolArr = [];
        this.schoolKeyWord = '';
      }
      if (val == 'school') {
        this.form.school = '';
        this.schoolValue = {};
        this.schoolArr = [];
        this.schoolKeyWord = '';
      }
    },

    showPopup(val) {
      if (val === 'group') {
        this.showGroupPop = true;
      }
      if (val === 'province') {
        if (this.provinceArr.length) {
          this.showProvincePop = true;
        } else {
          this.$Toast('暂无数据');
        }
      }
      if (val === 'city') {
        this.form.province
          ? (this.showCityPop = true)
          : this.$Toast('请先选择省份');
      }
      if (val === 'school') {
        if (!this.form.province || !this.form.city) {
          this.$Toast('请先选择省份和城市');
        } else {
          this.showSchoolPop = true;
        }
      }
    },
    confirmGroupPop(val) {
      this.group = val.id;
      val.id == 50
        ? (this.groupTxt = '游戏制作组')
        : (this.groupTxt = '模型制作组');
    },
    clickAreaFn(e) {
      let targets1 = 'van-picker__confirm'; // 确认
      let targets2 = 'van-picker__cancel'; // 取消
      let targets3 = 'van-overlay van-fade-enter van-fade-enter-active'; // 面板外
      if (
        e.target.className == targets1 ||
        e.target.className == targets2 ||
        e.target.className == targets3
      ) {
        this.showProvincePop = false;
        this.showCityPop = false;
        this.showSchoolPop = false;
        this.showGroupPop = false;
        this.schoolKeyWord = '';
      }
    },
    toDetail(wid) {
      this.$router.push(`details/${this.group}/${wid}`);
    }
  }
};
</script>

<style lang="scss" scoped>
#awardWorks {
  width: 750px;
  padding: 20px;
  margin-bottom: 20px;
  .form_item {
    font-size: 26px;
    height: 60px;
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    align-items: center;

    .input {
      height: 60px;
      width: 100%;
      border-radius: 4px;
      outline: none;
      background: #eee;
      text-indent: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      // 选中省市
      .select-div {
        line-height: 60px;
      }
    }
    /deep/ .van-picker-column,
    /deep/ .van-picker__cancel,
    /deep/ .van-picker__title,
    /deep/ .van-picker__confirm {
      font-size: 34px;
    }
    /deep/ .van-picker__toolbar {
      height: 70px;
    }
  }
  .award-box {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    .title {
      display: flex;
      flex-direction: column;
      .label {
        display: flex;
        flex-direction: column;
        // align-items: center;
        width: 200px;
        color: #ff874b;
        font-size: 38px;
        font-weight: 600;
        text-align: center;
        .txt {
          border-bottom: 6px solid #ff874b;
        }

        .txt {
          line-height: 1;
        }
      }
      .cut-line {
        width: 100%;
        height: 1px;
        background-color: #d3d3d3;
      }
    }
  }
  .bottom-wrap {
    // min-height: 200px;
    .label-choose {
      margin: 20px 0;
      .box {
        display: flex;
        color: #ff874b;
        font-size: 38px;
        font-weight: 600;
        li {
          width: 150px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 20px;
        }
        .checked {
          i {
            width: 150px;
            height: 6px;
            background-color: #ff874b;
            margin-top: 2px;
          }
        }
      }
    }

    .form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .form_item {
        width: 340px;
      }

      .uin-bar {
        display: flex;
        align-items: center;
        .icon-search {
          width: 60px;
          height: 60px;
          background-color: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
      .search-bar {
        font-size: 30px;
        height: 100px;
        width: 100%;
        display: flex;
        justify-content: space-around;
        .search-input {
          width: 100%;
          text-indent: 30px;
          border: 1px solid #ff874b;
          color: #ff874b;
        }
      }
    }
  }
}
.input:empty::before {
  line-height: 60px;
  color: #ccc;
  content: attr(placeholder);
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}
.placeholder {
  line-height: 60px;
  color: #ccc;
}
.no-more-data {
  width: 100%;
  text-align: center;
  margin: 20px 0;
}
#poOtherBox {
  height: 60px;
}
.btn-location {
  width: 72px;
  height: 201px;
  position: fixed;
  right: 0;
  top: 50%;
  margin-top: -86px;
  .img-to-other {
    width: 72px;
    height: 172px;
  }
  .img-to-top {
    width: 49px;
    height: 47px;
    float: right;
    margin-top: 20px;
  }
}
.icon-close {
  width: 60px;
  height: 60px;
  // font-size: 40px;
  color: #ff874b;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
